import { Button } from '@heroui/react'
import { Plus } from 'lucide-react'
import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useToggle } from 'usehooks-ts'
import { ConditionItem, CreateConditionModal } from './Conditions'
import { useSchema } from './utils'

export default function Issues() {
  const [searchParams] = useSearchParams()
  const id = searchParams.get('schema')

  const { data: selectedSchema } = useSchema(id)
  const [isCreating, toggleCreating] = useToggle(false)

  // Filter only conditions with mode === 'flag'
  const issueConditions = useMemo(
    () => selectedSchema?.schema?.conditions?.filter(c => c.mode === 'flag') ?? [],
    [selectedSchema],
  )

  return (
    <div className="flex w-full flex-col items-start gap-14">
      {!issueConditions?.length
        ? (
            <div className="mt-24 flex w-full flex-col items-center">
              <h1 className="mb-6 text-3xl font-semibold tracking-tighter">
                No issue flags configured.
              </h1>
              <p className="mb-10 text-center text-base text-gray-500">
                Issue flags help you identify and categorize problems in your calls automatically.
              </p>
            </div>
          )
        : (issueConditions.map((condition, index) => {
            // Find the original index in the full conditions array
            const originalIndex = selectedSchema?.schema?.conditions?.findIndex(c => c === condition) ?? index
            return (
              <ConditionItem
                key={originalIndex}
                condition={condition}
                index={originalIndex}
              />
            )
          }))}
      <Button
        disableRipple
        onPress={toggleCreating}
        variant="bordered"
        size="md"
        radius="sm"
        fullWidth
        className="mt-10"
      >
        <Plus size={16} />
        Add issue flag
      </Button>
      <CreateConditionModal
        isOpen={isCreating}
        onOpenChange={toggleCreating}
        defaultMode="flag"
        hideModePicker
        isWider
      />
    </div>
  )
}
